const breakpoints = ['320px', '481px', '648px', '720px', '937px', '1080px', '1224px', '1296px', '1352px', '1440px', '1920px'];

breakpoints.mobile320 = breakpoints[0];
breakpoints.mobile481 = breakpoints[1];
breakpoints.tablet648 = breakpoints[2];
breakpoints.tablet720 = breakpoints[3];
breakpoints.tablet937 = breakpoints[4];
breakpoints.tablet1080 = breakpoints[5];
breakpoints.desktop1224 = breakpoints[6];
breakpoints.desktop1296 = breakpoints[7];
breakpoints.desktop1352 = breakpoints[8];
breakpoints.desktop1440 = breakpoints[9];
breakpoints.desktop1920 = breakpoints[10];

export default breakpoints;
